module.exports = __webpack_public_path__ + "static/img/hezuo.4bba0e00.jpeg";